console.log('logoGarden.js loaded');

document.addEventListener("DOMContentLoaded", function () {
    let isEven  = function(x) { return !( x & 1 ); };

    const logoGarden = document.querySelectorAll('.bds-logogarden');

    if (logoGarden.length === 0) {
        return;
    }

    console.log('we got a garden folks');

    

    for (let i = 0; i < logoGarden.length; i++) {
        const garden = logoGarden[i];
        const gardenCards = garden.querySelector('.bds-logogarden__cards');
        const filters = garden.querySelectorAll('.bds-logogarden__filter');
        const ctaCard = garden.querySelector('.bds-logogarden__card.no-hidden');

function filterGarden(clients) {
    const slugs = clients.split(',').map(s => s.trim());
    const allCards = Array.from(gardenCards.querySelectorAll('.bds-logogarden__card'));
    let activeCards = [];

    // First, hide and de-prioritize everything (except .no-hidden)
    allCards.forEach(card => {
        if (!card.classList.contains('no-hidden')) {
            card.classList.add('hidden');
            card.tabIndex = -1;
        }
    });

    // Activate and reorder matching cards based on slug order
    slugs.forEach(slug => {
        const matchingCard = allCards.find(card =>
            card.getAttribute('data-slug') === slug && !card.classList.contains('no-hidden')
        );
        if (matchingCard) {
            matchingCard.classList.remove('hidden');
            matchingCard.tabIndex = 0;
            gardenCards.appendChild(matchingCard); // reorder in DOM
            activeCards.push(matchingCard);
        }
    });

    // Append .no-hidden cards to the end and ensure they're visible
    allCards
        .filter(card => card.classList.contains('no-hidden'))
        .forEach(card => {
            card.classList.remove('hidden');
            card.tabIndex = 0;
            gardenCards.appendChild(card); // move to end
        });

    // Shrink/grow logic
    if (activeCards.length > 8) {
        console.log('shrinks');
        gardenCards.classList.add('shrink-cards');
    } else {
        console.log('grows');
        gardenCards.classList.remove('shrink-cards');
    }

    // CTA card logic
    if (ctaCard && window.innerWidth < 768 && isEven(activeCards.length)) {
        ctaCard.classList.add('wide');
        ctaCard.style.height = activeCards[0]?.offsetHeight + 'px';
    } else if (ctaCard) {
        ctaCard.classList.remove('wide');
        ctaCard.style.height = '';
    }
}
        filterGarden(filters[0].getAttribute('data-clients'));
        filters[0].classList.add('active');
        

        for (let j = 0; j < filters.length; j++) {
            const filter = filters[j];
            const clients = filter.getAttribute('data-clients');
            filter.addEventListener('click', function () {
                document.querySelector('.bds-logogarden__filter.active').classList.remove('active');
                filter.classList.add('active');
                console.log('filter clicked', clients);
                filterGarden(clients);
            });
        }
        
        const bdsSelect = document.querySelector('.bds-select');

        if (bdsSelect) {
            const selected = bdsSelect.querySelector('.selected');
            const options = bdsSelect.querySelector('.options');
            const items = options.querySelectorAll('li');

            const selectItem = (item) => {
                const slug = item.getAttribute('data-value');
                console.log('bds-select changed', slug);
                selected.textContent = item.textContent;

                options.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
                item.classList.add('selected');

                filterGarden(slug);
                options.classList.add('hidden');
            };

            bdsSelect.addEventListener('click', () => {
                options.classList.toggle('hidden');
            });

            items.forEach(item => {
                item.addEventListener('click', () => {
                    selectItem(item);
                });
            });

            document.addEventListener('click', (e) => {
                if (!bdsSelect.contains(e.target)) {
                    options.classList.add('hidden');
                }
            });
        }

    }


});



//old version
// 
// // console.log('logoGarden.js loaded');

// document.addEventListener("DOMContentLoaded", function () {
//     let isEven  = function(x) { return !( x & 1 ); };

//     const logoGarden = document.querySelectorAll('.bds-logogarden');

//     if (logoGarden.length === 0) {
//         return;
//     }

//     console.log('we got a garden folks');

    

//     for (let i = 0; i < logoGarden.length; i++) {
//         const garden = logoGarden[i];
//         const gardenCards = garden.querySelector('.bds-logogarden__cards');
//         const filters = garden.querySelectorAll('.bds-logogarden__filter');
//         const ctaCard = garden.querySelector('.bds-logogarden__card.no-hidden');

//         function filterGarden(slug) {
//             const activeCards = garden.querySelectorAll('.bds-logogarden__card[data-cat-' + slug + ']');
//             const inactiveCards = garden.querySelectorAll('.bds-logogarden__card:not([data-cat-' + slug + ']):not(.no-hidden)');

//             if (activeCards.length > 8) {
//                 console.log('shrinks');
//                 gardenCards.classList.add('shrink-cards');
//             } else {
//                 console.log('grows');
//                 gardenCards.classList.remove('shrink-cards');
//             }

//             for (let j = 0; j < activeCards.length; j++) {
//                 activeCards[j].classList.remove('hidden');
//                 activeCards[j].tabIndex = 0;
//             }

//             for (let j = 0; j < inactiveCards.length; j++) {
//                 inactiveCards[j].classList.add('hidden');
//                 inactiveCards[j].tabIndex = -1;
//             }

//             if (ctaCard && window.innerWidth < 768 && isEven(activeCards.length)) {
//                 ctaCard.classList.add('wide');
//                 ctaCard.style.height = activeCards[0].offsetHeight + 'px';
//             } else if (ctaCard) {
//                 ctaCard.classList.remove('wide');
//                 ctaCard.style.height = '';
//             }

//         }

//         filterGarden(filters[0].getAttribute('data-cat'));
//         filters[0].classList.add('active');
        

//         for (let j = 0; j < filters.length; j++) {
//             const filter = filters[j];
//             const slug = filter.getAttribute('data-cat');
//             filter.addEventListener('click', function () {
//                 document.querySelector('.bds-logogarden__filter.active').classList.remove('active');
//                 filter.classList.add('active');
//                 console.log('filter clicked', slug);
//                 filterGarden(slug);
//             });
//         }

//         const catSelect = document.getElementById('bds-logogarden__filters__select');
//         if (catSelect) {
//             catSelect.addEventListener('change', function () {
//                 const slug = catSelect.value;
//                 console.log('select changed', slug);
//                 filterGarden(slug);
//             });
//         }

//     }


// });